var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-data-table',{staticClass:"small-font",attrs:{"headers":_vm.headers,"height":_vm.data.tableHeight,"items":_vm.links,"item-key":"id","footer-props":{
      'items-per-page-options': _vm.data.itemsPerPageOptions,
      'show-current-page': true,
      'show-first-last-page': true,
    },"options":_vm.options,"server-items-length":_vm.data.totalItems,"fixed-header":"","dense":"","loading":_vm.data.changingPage},on:{"update:options":function($event){_vm.options=$event}},scopedSlots:_vm._u([{key:"item.fromUrl",fn:function(ref){
    var item = ref.item;
return [_c('UrlLink',{attrs:{"to":{
          name: 'checkList-page-keywords',
          params: {
            domain: _vm.domain,
            propertyId: _vm.propertyId,
            pageId: item.fromPageId,
            pageUrl: _vm.toHex(item.fromUrl),
          },
        },"url":decodeURI(item.fromUrl)}})]}},{key:"item.linkRank",fn:function(ref){
        var item = ref.item;
return [_vm._v(" "+_vm._s(item.linkRank)+" of "+_vm._s(item.totalLinks)+" ")]}},{key:"item.toUrl",fn:function(ref){
        var item = ref.item;
return [(item.isExactMatch === false)?_c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
        var on = ref.on;
        var attrs = ref.attrs;
return [_c('v-icon',_vm._g(_vm._b({staticClass:"pr-1",attrs:{"small":"","color":"orange darken-2"}},'v-icon',attrs,false),on),[_vm._v(" mdi-alert-outline ")])]}}],null,true)},[_c('span',[_vm._v("Href was only loosely matched with the linked page")])]):_vm._e(),(item.toPageId)?_c('UrlLink',{attrs:{"to":{
          name: 'checkList-page-keywords',
          params: {
            domain: _vm.domain,
            propertyId: _vm.propertyId,
            pageId: item.toPageId,
            pageUrl: _vm.toHex(item.matchedToUrl),
          },
        },"url":decodeURI(item.toUrl),"hoverUrl":item.matchedToUrl,"maxLength":200}}):_c('span',[_vm._v(" "+_vm._s(item.toUrl)+" ")])]}},{key:"item.anchorText",fn:function(ref){
        var item = ref.item;
return [(item.imageUrl != null && item.imageUrl.length > 0)?_c('ImageAnchor',{attrs:{"imageUrl":item.imageUrl,"anchorText":item.anchorText}}):_c('span',[_vm._v(" "+_vm._s(item.anchorText)+" ")])]}}],null,true)}),_c('div',{staticClass:"toggle-wrapper"},[_c('VueToggles',{attrs:{"value":_vm.isIncoming,"height":"30","width":"110","uncheckedText":"Outgoing","checkedText":"Incoming","uncheckedBg":"#455a64","checkedBg":"#455a64"},on:{"click":function($event){return _vm.$emit('update:isIncoming', !_vm.isIncoming)}}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }